
import 'bootstrap'

import Metadata from 'metadata'
document.title = Metadata.name

import Toastr from 'toastr'
// Toastr.options.progressBar = true
Toastr.options.positionClass = 'toast-bottom-left'
Toastr.options.newestOnTop = false

import JQueryUtils from 'lib/jquery'
JQueryUtils.makeLongpressAvailable()

import $ from 'jquery'
import JqueryHelper from 'happi-helpers/jquery'
JqueryHelper($)
